import { render, staticRenderFns } from "./EnacAtplDashboardSkillsProgressDetails.vue?vue&type=template&id=56d992ef&scoped=true"
import script from "./EnacAtplDashboardSkillsProgressDetails.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardSkillsProgressDetails.vue?vue&type=script&lang=js"
import style0 from "./EnacAtplDashboardSkillsProgressDetails.vue?vue&type=style&index=0&id=56d992ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d992ef",
  null
  
)

export default component.exports